import {BeadChip} from "./bead-chip";
import {ChemicalLot} from "./chemical-lot";
import {Comment} from "./comment";
import {Sample} from "./sample";
import {Step} from "./step";


export class Plate{
  filter: any;
  remainingTime?: number;
  plateID: string = "";
  wgaPlateID: string;
  pgxPlateID: string;
  type: string;
  sourcePlates: SourcePlate[];
  samples?: Sample[];
  sender?: string;
  workFlow?: string;
  delivery?: string;
  status?: string;
  beadChipTransfer?: boolean;
  processSteps?: Step[];
  comments?: Comment[];
  chemicalLots?: ChemicalLot[];
  beadChips?: BeadChip[];
  redoBeadChips?: BeadChip[];
  action:string;
  actionStartTime:Date;
  actionRunTime:number;
  remGraphic?:string;
  endTime?: Date;
  remainingMinutes?: number;
  progressValue?: number;
  processingTime?: number;
  startTime?: Date;
  rem?:number;
  version?:number;
  chemicalPop?:string;
  labID?: string;
  sampleType?: string;
  minimumTemperature: string;
  maximumTemperature: string;
  mergePlateIDs: string[];
  archiveData: any[];
  storage: string;
  storagePlate: boolean;
  lysisPlateID: string;
  dnaPlateID: string;
  aliquotPlateID: string
  lastUpdatedPlateID:string
  processFlowName?: string;
  scanHorizontal?: boolean=true;
  priority?:number;
  reRun?:boolean = false;
  magMixPlate?: string;
  addNewPlateMeta? : boolean = false
  sendHistoryEvents?: boolean = true
  reportingFileName?: string = "";
  dueDate?: Date;
  lastModifiedDate?: Date;
  adminChangeTimeStamp?: Date;
  latestUserComment?:Comment = null;
  projectID:string;
  batchID:string;
  hasRedoSamples?: boolean;
}

export class SourcePlate {
    plateID: string;
    lastUpdatedPlateID?: string;
    status: string;
    sampleType: string;
    processFlowName?: string;
    redoType?: string;
    redoSampleType?: string;
    sourcePlateIDs:string[];
}
